// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#AdminOpsConfig {
  justify-content: flex-start;
}
#AdminOpsConfig .ops-config-update-button {
  min-width: 160px;
}
#AdminOpsConfig .ops-config-body {
  width: 100%;
  height: calc(100vh - var(--page-header-height));
  overflow-y: auto;
  overflow-x: hidden;
  box-sizing: border-box;
  padding: 0 16px 60px;
}
#AdminOpsConfig .ops-config-loading {
  display: flex;
  justify-content: center;
  padding: 32px;
  color: var(--dark-color-main);
}
#AdminOpsConfig .ops-config-num-row, #AdminOpsConfig .ops-config-bool-row {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 12px;
}
#AdminOpsConfig .ops-config-num-input {
  width: 200px;
}
#AdminOpsConfig .ops-config-num-input.is-error .textinput {
  border-color: var(--ops-error);
}
#AdminOpsConfig .ops-config-unit {
  font-size: 12px;
  color: var(--font_active_sub_color);
}
#AdminOpsConfig .ops-config-switch {
  position: relative;
  display: inline-flex;
  align-items: center;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
}
#AdminOpsConfig .ops-config-switch input[type=checkbox] {
  position: absolute;
  opacity: 0;
  width: 0;
  height: 0;
  pointer-events: none;
}
#AdminOpsConfig .ops-config-switch .switch-track {
  position: relative;
  display: inline-block;
  width: 52px;
  height: 28px;
  background-color: var(--dark-color-light);
  border-radius: 999px;
  transition: background-color 0.2s ease-in-out;
}
#AdminOpsConfig .ops-config-switch .switch-thumb {
  position: absolute;
  top: 3px;
  left: 3px;
  width: 22px;
  height: 22px;
  background-color: var(--white-color-lightest);
  border-radius: 50%;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
  transition: transform 0.2s ease-in-out;
}
#AdminOpsConfig .ops-config-switch.on .switch-track {
  background-color: var(--primary-color-main);
}
#AdminOpsConfig .ops-config-switch.on .switch-thumb {
  transform: translateX(24px);
}
#AdminOpsConfig .ops-config-state {
  font-size: 18px;
  font-weight: 800;
  letter-spacing: 1px;
  color: var(--font_active_hidden_color);
}
#AdminOpsConfig .ops-config-state.on {
  color: var(--primary-color-main);
}

#ops-config-confirm-modal .ev-modal-container {
  width: 560px;
  max-width: calc(100vw - 48px);
}
#ops-config-confirm-modal .ops-config-confirm {
  width: 100%;
  text-align: left;
  color: var(--dark-color-dark);
}
#ops-config-confirm-modal .ops-config-changes {
  display: flex;
  flex-direction: column;
  border: 1px solid var(--border-weak-color);
  border-radius: 6px;
  overflow: hidden;
}
#ops-config-confirm-modal .ops-config-change {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  gap: 12px;
  align-items: center;
  padding: 10px 12px;
  border-top: 1px solid #edeef1;
}
#ops-config-confirm-modal .ops-config-change:first-child {
  border-top: none;
}
#ops-config-confirm-modal .ops-config-change-name {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
}
#ops-config-confirm-modal .ops-config-change-label {
  font-weight: 700;
}
#ops-config-confirm-modal .ops-config-change-key {
  font-size: 12px;
  color: #838996;
  font-family: ui-monospace, SFMono-Regular, Menlo, monospace;
}
#ops-config-confirm-modal .ops-config-change-values {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  font-variant-numeric: tabular-nums;
}
#ops-config-confirm-modal .ops-config-change-values .bi {
  font-size: 12px;
  color: #838996;
}
#ops-config-confirm-modal .ops-config-change-domains {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 2px;
  min-width: 0;
  word-break: break-all;
}
#ops-config-confirm-modal .ops-config-change-domains .ops-config-change-before {
  text-decoration: none;
}
#ops-config-confirm-modal .ops-config-change-before {
  color: #838996;
  text-decoration: line-through;
}
#ops-config-confirm-modal .ops-config-change-after {
  font-weight: 700;
  color: var(--primary-color-main);
}`, "",{"version":3,"sources":["webpack://./src/components/admin/parts/ops/AdminOpsConfig.scss"],"names":[],"mappings":"AACA;EACI,2BAAA;AAAJ;AAEI;EACI,gBAAA;AAAR;AAGI;EACI,WAAA;EACA,+CAAA;EACA,gBAAA;EACA,kBAAA;EACA,sBAAA;EACA,oBAAA;AADR;AAII;EACI,aAAA;EACA,uBAAA;EACA,aAAA;EACA,6BAAA;AAFR;AAKI;EACI,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,SAAA;AAHR;AAMI;EACI,YAAA;AAJR;AAMQ;EACI,8BAAA;AAJZ;AAQI;EACI,eAAA;EACA,mCAAA;AANR;AAUI;EACI,kBAAA;EACA,oBAAA;EACA,mBAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;AARR;AAUQ;EACI,kBAAA;EACA,UAAA;EACA,QAAA;EACA,SAAA;EACA,oBAAA;AARZ;AAWQ;EACI,kBAAA;EACA,qBAAA;EACA,WAAA;EACA,YAAA;EACA,yCAAA;EACA,oBAAA;EACA,6CAAA;AATZ;AAYQ;EACI,kBAAA;EACA,QAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,6CAAA;EACA,kBAAA;EACA,wCAAA;EACA,sCAAA;AAVZ;AAcY;EACI,2CAAA;AAZhB;AAcY;EACI,2BAAA;AAZhB;AAiBI;EACI,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,sCAAA;AAfR;AAiBQ;EACI,gCAAA;AAfZ;;AAsBI;EACI,YAAA;EACA,6BAAA;AAnBR;AAsBI;EACI,WAAA;EACA,gBAAA;EACA,6BAAA;AApBR;AAuBI;EACI,aAAA;EACA,sBAAA;EACA,0CAAA;EACA,kBAAA;EACA,gBAAA;AArBR;AAwBI;EACI,aAAA;EACA,0CAAA;EACA,SAAA;EACA,mBAAA;EACA,kBAAA;EACA,6BAAA;AAtBR;AAwBQ;EACI,gBAAA;AAtBZ;AA0BI;EACI,aAAA;EACA,sBAAA;EACA,QAAA;EACA,YAAA;AAxBR;AA2BI;EACI,gBAAA;AAzBR;AA4BI;EACI,eAAA;EACA,cAAA;EACA,2DAAA;AA1BR;AA6BI;EACI,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,QAAA;EACA,kCAAA;AA3BR;AA6BQ;EACI,eAAA;EACA,cAAA;AA3BZ;AA+BI;EACI,aAAA;EACA,sBAAA;EACA,qBAAA;EACA,QAAA;EACA,YAAA;EACA,qBAAA;AA7BR;AA+BQ;EACI,qBAAA;AA7BZ;AAiCI;EACI,cAAA;EACA,6BAAA;AA/BR;AAkCI;EACI,gBAAA;EACA,gCAAA;AAhCR","sourcesContent":["// 利用設定（デザイン PRizmo_Admin.dc.html「利用設定 (t_user.config)」）\n#AdminOpsConfig {\n    justify-content: flex-start;\n\n    .ops-config-update-button {\n        min-width: 160px;\n    }\n\n    .ops-config-body {\n        width: 100%;\n        height: calc(100vh - var(--page-header-height));\n        overflow-y: auto;\n        overflow-x: hidden;\n        box-sizing: border-box;\n        padding: 0 16px 60px;\n    }\n\n    .ops-config-loading {\n        display: flex;\n        justify-content: center;\n        padding: 32px;\n        color: var(--dark-color-main);\n    }\n\n    .ops-config-num-row, .ops-config-bool-row {\n        display: flex;\n        flex-direction: row;\n        align-items: center;\n        gap: 12px;\n    }\n\n    .ops-config-num-input {\n        width: 200px;\n\n        &.is-error .textinput {\n            border-color: var(--ops-error);\n        }\n    }\n\n    .ops-config-unit {\n        font-size: 12px;\n        color: var(--font_active_sub_color);\n    }\n\n    // ON/OFF トグル（デモページ作成・有人引き継ぎ設定のスイッチと同じ寸法）\n    .ops-config-switch {\n        position: relative;\n        display: inline-flex;\n        align-items: center;\n        cursor: pointer;\n        user-select: none;\n\n        input[type=\"checkbox\"] {\n            position: absolute;\n            opacity: 0;\n            width: 0;\n            height: 0;\n            pointer-events: none;\n        }\n\n        .switch-track {\n            position: relative;\n            display: inline-block;\n            width: 52px;\n            height: 28px;\n            background-color: var(--dark-color-light);\n            border-radius: 999px;\n            transition: background-color 0.2s ease-in-out;\n        }\n\n        .switch-thumb {\n            position: absolute;\n            top: 3px;\n            left: 3px;\n            width: 22px;\n            height: 22px;\n            background-color: var(--white-color-lightest);\n            border-radius: 50%;\n            box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);\n            transition: transform 0.2s ease-in-out;\n        }\n\n        &.on {\n            .switch-track {\n                background-color: var(--primary-color-main);\n            }\n            .switch-thumb {\n                transform: translateX(24px);\n            }\n        }\n    }\n\n    .ops-config-state {\n        font-size: 18px;\n        font-weight: 800;\n        letter-spacing: 1px;\n        color: var(--font_active_hidden_color);\n\n        &.on {\n            color: var(--primary-color-main);\n        }\n    }\n}\n\n// 更新確認（変更点の一覧）\n#ops-config-confirm-modal {\n    .ev-modal-container {\n        width: 560px;\n        max-width: calc(100vw - 48px);\n    }\n\n    .ops-config-confirm {\n        width: 100%;\n        text-align: left;\n        color: var(--dark-color-dark);\n    }\n\n    .ops-config-changes {\n        display: flex;\n        flex-direction: column;\n        border: 1px solid var(--border-weak-color);\n        border-radius: 6px;\n        overflow: hidden;\n    }\n\n    .ops-config-change {\n        display: grid;\n        grid-template-columns: minmax(0, 1fr) auto;\n        gap: 12px;\n        align-items: center;\n        padding: 10px 12px;\n        border-top: 1px solid #edeef1;\n\n        &:first-child {\n            border-top: none;\n        }\n    }\n\n    .ops-config-change-name {\n        display: flex;\n        flex-direction: column;\n        gap: 2px;\n        min-width: 0;\n    }\n\n    .ops-config-change-label {\n        font-weight: 700;\n    }\n\n    .ops-config-change-key {\n        font-size: 12px;\n        color: #838996;\n        font-family: ui-monospace, SFMono-Regular, Menlo, monospace;\n    }\n\n    .ops-config-change-values {\n        display: flex;\n        flex-direction: row;\n        align-items: center;\n        gap: 8px;\n        font-variant-numeric: tabular-nums;\n\n        .bi {\n            font-size: 12px;\n            color: #838996;\n        }\n    }\n\n    .ops-config-change-domains {\n        display: flex;\n        flex-direction: column;\n        align-items: flex-end;\n        gap: 2px;\n        min-width: 0;\n        word-break: break-all;\n\n        .ops-config-change-before {\n            text-decoration: none;\n        }\n    }\n\n    .ops-config-change-before {\n        color: #838996;\n        text-decoration: line-through;\n    }\n\n    .ops-config-change-after {\n        font-weight: 700;\n        color: var(--primary-color-main);\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
